import React from "react";

export default function Footer() {
    return (
        <footer className="bg-primary text-white px-4 py-6 md:min-h-[80px]">
            <div className="max-w-6xl mx-auto">
                {/*<div className="flex flex-col gap-8 md:hidden mt-6">*/}
                {/*    <div>*/}
                {/*        <h3 className="font-bold text-lg uppercase tracking-wide mb-2">Queetstone</h3>*/}
                {/*        <p>720 Seneca St Ste 107</p>*/}
                {/*        <p>#490</p>*/}
                {/*        <p>Seattle, WA 98101</p>*/}
                {/*    </div>*/}
                {/*</div>*/}

                <div className="text-center text-xs text-gray-300 mt-6 md:mt-2">
                    &copy; {new Date().getFullYear()} Queetstone. All rights reserved.
                </div>
            </div>
        </footer>
    );
}
